<template>
  <form v-if="!loading" @submit.prevent="onSubmit()">
    <div class="row mb-2">
      <div class="col-12">
        <b-checkbox v-model="product.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Código EAN"
          v-model="product.ean_code"
          v-app-regex-filter="/\D/g"
          :maxlength="13"
          :errors="errors.ean_code"
          required
        ></app-input>
        <div v-if="!$v.product.ean_code.minLength" class="error">
          O código ean deve possuir 13 dígitos
        </div>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Código"
          v-model="product.code"
          :maxlength="8"
          :errors="errors.code"
        ></app-input>
        <div v-if="!$v.product.code.minLength" class="error">
          O código deve possuir 8 dígitos
        </div>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Nome"
          v-model="product.name"
          :errors="errors.name"
          required
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Família"
          v-model="product.family"
          :errors="errors.family"
          required
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Marca"
          v-model="product.brand"
          :errors="errors.brand"
          required
        ></app-input>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import ProductService from '@/services/product.service';
import ToastMixin from '@/mixins/ToastifyMixin';

import { required, minLength, maxLength } from 'vuelidate/src/validators';

export default {
  name: 'product-form',
  props: ['id', 'errors', 'saving'],
  mixins: [ToastMixin],
  data: () => {
    return {
      loading: true,
      product: {
        active: true,
        ean_code: null,
        code: null,
        name: null,
        family: null,
        brand: null,
      },
    };
  },
  validations() {
    return {
      product: {
        ean_code: {
          required,
          minLength: minLength(13),
          maxLength: maxLength(13),
        },
        code: this.code ? { minLength: minLength(8), maxLength: maxLength(8) } : { minLength: minLength(0)},
        name: { required },
        family: { required },
        brand: { required },
      },
    };
  },
  methods: {
    loadProduct(id) {
      ProductService.getId(id)
        .then(({ data }) => {
          this.product = data;
        })
        .catch(() => this.toastify('Erro ao carregar Produto.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', this.product);
    },
  },
  beforeMount() {
    if (this.id) this.loadProduct(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.error {
  font-size: 0.8em;
  color: #ff6363;
}
</style>
